import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Box,
  CircularProgress,
} from '@mui/material';
import {
  InvitationCreateRequest,
  OrganizationRole,
} from '../../services/organizationApi';

interface InviteMemberDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => void;
  form: InvitationCreateRequest;
  setForm: (form: InvitationCreateRequest) => void;
  loading: boolean;
}

const InviteMemberDialog: React.FC<InviteMemberDialogProps> = ({
  open,
  onClose,
  onSubmit,
  form,
  setForm,
  loading,
}) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSubmit();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <form onSubmit={handleSubmit}>
        <DialogTitle>Invite Member</DialogTitle>
        <DialogContent>
          <Box sx={{ pt: 1 }}>
            <TextField
              fullWidth
              label="Email Address"
              type="email"
              value={form.email}
              onChange={(e) => setForm({ ...form, email: e.target.value })}
              margin="normal"
              required
              disabled={loading}
              placeholder="colleague@company.com"
            />
            <FormControl fullWidth margin="normal">
              <InputLabel>Role</InputLabel>
              <Select
                value={form.role}
                label="Role"
                onChange={(e) => setForm({ ...form, role: e.target.value as OrganizationRole })}
                disabled={loading}
              >
                <MenuItem value={OrganizationRole.VIEWER}>Viewer (Read-only access)</MenuItem>
                <MenuItem value={OrganizationRole.MEMBER}>Member (Standard access)</MenuItem>
                <MenuItem value={OrganizationRole.ADMIN}>Admin (Manage members & invitations)</MenuItem>
              </Select>
            </FormControl>

            <TextField
              fullWidth
              label="Custom Message (Optional)"
              value={form.message || ''}
              onChange={(e) => setForm({ ...form, message: e.target.value })}
              margin="normal"
              multiline
              rows={3}
              disabled={loading}
              placeholder="Welcome to our organization! We're excited to have you join us."
            />
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button
            type="submit"
            variant="contained"
            disabled={loading || !form.email}
            startIcon={loading ? <CircularProgress size={20} /> : null}
          >
            {loading ? 'Sending Invitation...' : 'Send Invitation'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default InviteMemberDialog;
